<template>
    <v-chip-group>
        <v-chip v-for="{ _id, url, fileName } in brochures" :key="_id" :href="url" download color="primary" outlined class="rounded-0">{{ fileName }}</v-chip>
    </v-chip-group>
</template>

<script>
export default {
    props: {
        brochures: Array,
    },
};
</script>

<style></style>
